import React, { useContext, useMemo } from "react";
import Flex from "Trackalyze/Flex";
import { FilteredTracksContext } from "~/Context/FilteredTracksContext";
import { ImportContext } from "~/Context/ImportContext";
import Typo from "Trackalyze/Typo";
import { useTranslation } from "react-i18next";
import Switch from "Trackalyze/Switch";
import Card from "Trackalyze/Card";
import { ListItem } from "Trackalyze/List";

const FilterWaypoints = (props) => {
  const { t } = useTranslation();

  const {
    filterWaypoints,
    setFilterWaypoints,
    filterActivities,
    filterFavorites, // new
    filterGpxTypes,
    handleFilterTracks,
    searchQuery,
  } = useContext(FilteredTracksContext);
  const { tracksIndex } = useContext(ImportContext);

  const isSelected = filterWaypoints.includes("hasWaypoints");

  const handleSwitch = (val) => {
    setFilterWaypoints((prev) => {
      if (val) {
        if (!prev.includes("hasWaypoints")) return [...prev, "hasWaypoints"];
        return prev;
      } else {
        return prev.filter((id) => id !== "hasWaypoints");
      }
    });
  };

  // Calculate tracks filtered by activities and GPX types
  const tracksFilteredByOthers = useMemo(() => {
    return handleFilterTracks(
      tracksIndex,
      filterActivities,
      [],
      filterFavorites || [],
      filterGpxTypes,
      [], // groups
      searchQuery,
    );
  }, [
    tracksIndex,
    filterActivities,
    filterFavorites,
    filterGpxTypes,
    handleFilterTracks,
    searchQuery,
  ]);

  const waypointCount = useMemo(() => {
    return tracksFilteredByOthers.filter((t) => t.wayPointsCount > 0).length;
  }, [tracksFilteredByOthers]);

  if (!props.standalone && waypointCount === 0 && !isSelected) return null;

  return (
    <ListItem>
      <Flex vertical spacing="3" padding="s">
        <Flex spacing="3" out itemscenter>
          <Flex spacing="2" itemscenter>
            <Typo type="label" size="l">
              {t("trackManager.filterHasWaypoints")}
            </Typo>
            <Typo
              type="label"
              size="l"
              className="ta-color-text_on-surface-lower"
            >
              {waypointCount}
            </Typo>
          </Flex>
          <Switch switched={isSelected} callBack={handleSwitch} />
        </Flex>
      </Flex>
    </ListItem>
  );
};

export default React.memo(FilterWaypoints);
